import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ToolCallSwapAgentIcon(props: SimpleIconInterface): JSX.Element {
  const { stroke = IconColors.DarkGrey, ...rest } = props;

  return (
    <SimpleIcon {...rest} stroke={stroke} viewBoxDimensions="0 0 24 24">
      <path
        d="M6.972 10.964 7.691 12a5.251 5.251 0 0 0 8.618 0l0.719 -1.036"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M2.25 23.25a10.669 10.669 0 0 1 19.5 0"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m3 6.75 18 0"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m6 6.751 1.66 -4.976A1.5 1.5 0 0 1 9.854 0.963l1.374 0.825a1.5 1.5 0 0 0 1.544 0l1.374 -0.825a1.5 1.5 0 0 1 2.194 0.812L18 6.751"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m12 23.25 -3.411 -5.78 -1.839 4.28L9 23.25"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m12 23.25 3.411 -5.78 1.839 4.28 -2.25 1.5"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M18.75 6.751v1.5a3 3 0 0 1 -3 3h-1.629a1.5 1.5 0 0 1 -1.06 -0.44L12 9.75l-1.061 1.06a1.5 1.5 0 0 1 -1.06 0.44H8.25a3 3 0 0 1 -3 -3v-1.5"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </SimpleIcon>
  );
}
